export type ApiKorpoCodeResponseStatus = 'OK' | 'ERR' | 'IN_USAGE' | 'USED';

export const validKorpoCodeResponseStatus: ApiKorpoCodeResponseStatus[] = ['OK', 'IN_USAGE'];

export interface ApiKorpoCodeResponse {
  status: ApiKorpoCodeResponseStatus;
  productIdn: string;
  employerIdn: string;
  statementPl: string;
  statementEng: string;
}
